/* DDI Sibling Swatch — collection card live swap
       Runs once per page via window.__ddiSwapInit guard.
       Document-level capture delegation survives custom-element re-renders.
       Bundle detection: products tagged "Bundles" get "View Product" CTA. */
    (function () {
      if (window.__ddiSwapInit) return;
      window.__ddiSwapInit = true;

      function fmtMoney(cents) {
        var fmt = (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '$';
        var d = (cents / 100).toFixed(2);
        return fmt
          .replace(/\{\{\s*amount\s*\}\}/g, d)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, d.replace('.', ','));
      }

      function isBundle(product) {
        if (!product.tags) return false;
        var tags = Array.isArray(product.tags)
          ? product.tags
          : product.tags.split(',').map(function (t) { return t.trim(); });
        return tags.indexOf('Bundles') !== -1;
      }

      /* capture:true fires before InstantPage / any other nav handler intercepts */
      document.addEventListener('click', function (e) {
        var swatch = e.target.closest && e.target.closest('.ddi-swatch');
        if (!swatch) return;
        var card = swatch.closest('[data-js-product-item]');
        if (!card) return;

        e.preventDefault();
        e.stopPropagation();

        var url = swatch.href || swatch.getAttribute('href') || '';
        var handle = url.replace(/.*\/products\//, '').split('?')[0].split('#')[0];
        if (!handle) return;

        swatch.classList.add('is-loading');

        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var productUrl = '/products/' + p.handle;

            /* image link href */
            var imgLink = card.querySelector('a[data-js-product-item-image]');
            if (imgLink) imgLink.href = productUrl;

            /* main image - direct src update for DDI cards; lazysizes fallback for Krown cards */
            var mainImg = imgLink && imgLink.querySelector('img');
            if (mainImg && p.featured_image) {
              var base = (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image;
              mainImg.alt = p.title;
              if (mainImg.classList.contains('lazyload') || mainImg.getAttribute('data-src')) {
                /* Krown lazysizes pattern */
                mainImg.setAttribute('data-src', base + '?width=1500');
                mainImg.setAttribute('data-srcset',
                  base + '?width=400 400w, ' +
                  base + '?width=800 800w, ' +
                  base + '?width=1500 1500w');
                var lazyParent = mainImg.closest('.lazy-image');
                if (lazyParent) lazyParent.classList.remove('lazyloaded');
                mainImg.classList.remove('lazyloaded');
                mainImg.classList.add('lazyload');
                if (window.lazySizes) window.lazySizes.loader.unveil(mainImg);
              } else {
                /* DDI card: plain img src */
                mainImg.src = base + '?width=800';
                mainImg.srcset = base + '?width=400 400w, ' + base + '?width=800 800w';
              }
            }

            /* title link - DDI card (.ddi-card-title) or Krown native fallback */
            var titleLink = card.querySelector('a.ddi-card-title') || card.querySelector('a.product-item__title');
            if (titleLink) {
              titleLink.href = productUrl;
              titleLink.title = p.title;
              titleLink.textContent = p.title;
            }

            /* price - DDI card ([data-js-product-price-original]) */
            var priceOrigEl = card.querySelector('[data-js-product-price-original]');
            var priceCompEl = card.querySelector('.product-price--compare');
            if (priceOrigEl) priceOrigEl.textContent = fmtMoney(p.price);
            if (priceCompEl) {
              if (p.compare_at_price && p.compare_at_price > p.price) {
                priceCompEl.textContent = fmtMoney(p.compare_at_price);
                priceCompEl.hidden = false;
              } else {
                priceCompEl.hidden = true;
              }
            }

            /* ATC link - DDI card uses <a class="card__atc">, update href to product URL */
            var atcLink = card.querySelector('a.card__atc');
            if (atcLink) atcLink.href = productUrl;

            /* variant id for ATC form */
            var firstVariant = p.variants && p.variants[0];
            var variantInput = card.querySelector('input[name="id"]');
            if (variantInput && firstVariant) variantInput.value = firstVariant.id;

            /* ATC button — "View Product" for bundles, else Add to cart / Sold out */
            var atcBtn = card.querySelector('button[name="add"]');
            if (atcBtn) {
              if (isBundle(p)) {
                atcBtn.textContent = 'View Product';
                atcBtn.setAttribute('data-ddi-bundle-url', productUrl);
                atcBtn.type = 'button';
                atcBtn.onclick = function () { window.location.href = productUrl; };
              } else {
                var avail = firstVariant ? firstVariant.available : !!p.available;
                atcBtn.textContent = avail ? 'Add to cart' : 'Sold out';
                atcBtn.disabled = !avail;
                atcBtn.removeAttribute('data-ddi-bundle-url');
                atcBtn.type = 'submit';
                atcBtn.onclick = null;
              }
            }

            /* swap swatch block to show the target product's own sibling list */
            var targetCard = document.getElementById('product-item-' + p.id);
            var curBlock = card.querySelector('[data-ddi-swatches]');
            if (curBlock) {
              var srcBlock = null;
              if (targetCard && targetCard !== card) {
                /* first swap away from original — save original block for later revert */
                if (!card.__ddiOrigBlock) {
                  card.__ddiOrigBlock = curBlock.cloneNode(true);
                  Array.from(card.__ddiOrigBlock.querySelectorAll('script,style')).forEach(function (n) { n.parentNode.removeChild(n); });
                  Array.from(card.__ddiOrigBlock.querySelectorAll('.is-loading')).forEach(function (n) { n.classList.remove('is-loading'); });
                }
                srcBlock = targetCard.querySelector('[data-ddi-swatches]');
              } else if (targetCard === card && card.__ddiOrigBlock) {
                /* reverting to original product — restore saved block */
                srcBlock = card.__ddiOrigBlock;
              }
              if (srcBlock) {
                var cloned = srcBlock.cloneNode(true);
                /* strip <script> and <style> — already in DOM from original render */
                Array.from(cloned.querySelectorAll('script,style')).forEach(function (n) { n.parentNode.removeChild(n); });
                curBlock.parentNode.replaceChild(cloned, curBlock);
              }
            }

            /* active swatch state — ensure correct is-active after any swap */
            Array.from(card.querySelectorAll('.ddi-swatch')).forEach(function (sw) {
              var swUrl = sw.href || sw.getAttribute('href') || '';
              var swHandle = swUrl.replace(/.*\/products\//, '').split('?')[0].split('#')[0];
              var active = swHandle === p.handle;
              sw.classList.toggle('is-active', active);
              if (active) sw.setAttribute('aria-current', 'true');
              else sw.removeAttribute('aria-current');
            });
          })
          .catch(function (err) { console.warn('[DDI swatch swap]', err); })
          .then(function () { swatch.classList.remove('is-loading'); });

      }, true); /* capture phase */

    }());
